import React from 'react';
import { Box, Typography, Container, Grid, IconButton } from '@mui/material';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import colors from '../../theme/colors';
import { Parallax } from 'react-scroll-parallax';


const team = [
  {
    name: 'Yahya Sbini',
    role: 'Operations Manager & team coordination',
    img: require('../../assets/team4.jpeg'),
    linkedin: 'https://www.linkedin.com/in/yahyasbini/',
  },
  {
    name: 'Nabil Alsaadi',
    role: 'Technical Lead & Software Engineer',
    img: require('../../assets/team8.jpeg'),
    linkedin: 'https://linkedin.com/in/nabil-alsaadi',
  },
  {
    name: 'Diana Anka',
    role: 'Social Media & Marketing Manager',
    img: require('../../assets/team5.jpeg'),
    linkedin: 'https://www.linkedin.com/in/diana-anka',
  },
  {
    name: 'Omar Aboulubdeh',
    role: 'Finance & Investment Manager',
    img: require('../../assets/team2.jpeg'),
    linkedin: 'https://www.linkedin.com/in/omar-aboulubdeh/',
  },
  {
    name: 'Ammar Alnatour',
    role: 'Events & Courses Coordinator',
    img: require('../../assets/team3.jpeg'),
    linkedin: 'https://www.linkedin.com/in/mohammedammaralnatour',
  },
  // {
  //   name: 'Hasan Derawan',
  //   role: 'Co-Founder & Strategic Advisor',
  //   img: require('../../assets/team6.jpeg'),
  //   linkedin: 'https://www.linkedin.com/in/hasan-derawan/',
  // },
  // {
  //   name: 'Rabii Desouki',
  //   role: 'Co-Founder & Strategic Advisor',
  //   img: require('../../assets/team7.jpeg'),
  //   linkedin: 'https://www.linkedin.com/in/rabii-desouki/',
  // },
  
  
];

const teamCardSx = {
  textAlign: 'center',
  p: 4,
  borderRadius: 4,
  background: colors.paper,
  boxShadow: 4,
  transition: 'transform 0.2s, box-shadow 0.2s',
  border: `2px solid ${colors.lightGreen}`,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  minHeight: 340,
  '&:hover': {
    transform: 'translateY(-10px) scale(1.04)',
    boxShadow: 8,
  },
};

const TeamSection: React.FC = () => (
  <>
    <Parallax speed={-10}>
      <Box sx={{ position: 'absolute', top: -140, right: '0%', transform: 'translateX(50%)', width: '90%', height: 800, opacity: 0.10, zIndex: 0 }}>
        <img src={require('../../assets/syrdevuae_logo.svg').default} alt="SyrDevUae Illustration" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
      </Box>
    </Parallax>
  <Box sx={{ py: 8, position: 'relative', overflow: 'hidden' }} id="team">
    <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
      <Typography variant="h3" color="primary" fontWeight={700} gutterBottom>
        Meet the Team
      </Typography>
      <Box sx={{ height: 4, width: 48, borderRadius: 2, background: colors.accent, mx: 'auto', mb: 6 }} />
      <Grid container spacing={3} justifyContent="center">
        {team.map((member) => (
          <Grid size={{ xs: 12, sm: 6, md: 2.4 }} key={member.name}>
            <Box sx={teamCardSx}>
              <img src={member.img} alt={member.name} style={{ width: 120, height: 120, margin: '0 auto 16px', borderRadius: '50%', border: `4px solid ${colors.lightGreen}`, boxShadow: '0 4px 16px 0 rgba(33,150,243,0.10)', objectFit: 'cover', background: colors.paper, transition: 'box-shadow 0.2s, transform 0.2s' }} />
              <Typography variant="body1" fontWeight={700} sx={{ mt: 2 }}>{member.name}</Typography>
              {member.role && (
                <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>{member.role}</Typography>
              )}
              <IconButton href={member.linkedin} target="_blank" rel="noopener" sx={{ color: colors.green, mt: 1 }}>
                <LinkedInIcon />
              </IconButton>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Container>
  </Box>
  </>
);

export default TeamSection; 